/**
 * Composable per le opzioni predefinite dei DatePicker di Element UI
 *
 * Fornisce configurazione centralizzata per tutti i date picker nell'applicazione.
 * Sostituisce il pattern Vue.prototype.$pickerOptions deprecato.
 *
 * @returns Oggetto con le opzioni standard per Element UI DatePicker
 *
 * @example
 * ```vue
 * <script setup lang="ts">
 * import { useElementUIDatePickerOptions } from '@/composables/useElementUIDatePickerOptions'
 *
 * const pickerOptions = useElementUIDatePickerOptions()
 * </script>
 *
 * <template>
 *   <el-date-picker :picker-options="pickerOptions" />
 * </template>
 * ```
 */
export function useElementUIDatePickerOptions() {
	return {
		/** Primo giorno della settimana (1 = Lunedì, 0 = Domenica) */
		firstDayOfWeek: 1,

		// Eventuali altre opzioni comuni possono essere aggiunte qui
		// format: 'dd/MM/yyyy',
		// valueFormat: 'yyyy-MM-dd',
		// etc.
	} as const;
}

/**
 * Alias per compatibilità con naming esistente se necessario
 * @deprecated Usa useElementUIDatePickerOptions invece
 */
export const useDatePickerOptions = useElementUIDatePickerOptions;
